
define('text!modules/campaign/bulkedit/templates/targeting.html',[],function () { return '<div class="w-Targeting targeting-tabs"></div>\n<div class="strategy-targeting-loader view-loader"></div>';});

